export enum RolePurposeConstants {
  MilestoneApprover = "Approver",
  ProjectTeam = "Project Team",
  Distribution = "Distribution",
}
